import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";

export const CancelButton = (props) => {
	const { label, handleOnClick, style } = props;

	return (
		<Button
			variant="contained"
			style={{
				padding: "8px 34px",
				borderRadius: 50,
				backgroundColor: "#ebebeb",
				borderColor: "#ebebeb",
				color: "#585858",
				textAlign: "center",
				whiteSpace: "nowrap",
				...style,
			}}
			onClick={() => {
				if (handleOnClick) {
					handleOnClick();
				}
			}}
		>
			{label}
		</Button>
	);
};

CancelButton.propTypes = {
	label: PropTypes.string,
	handleOnClick: PropTypes.func,
	style: PropTypes.object,
};
